import { render, staticRenderFns } from "./FinalizeOrderTable.vue?vue&type=template&id=4985bd0a&scoped=true&"
import script from "./FinalizeOrderTable.vue?vue&type=script&lang=js&"
export * from "./FinalizeOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeOrderTable.vue?vue&type=style&index=0&id=4985bd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985bd0a",
  null
  
)

export default component.exports